import type { RequestOptions } from '@@/plugin-request/request';
import type { RequestConfig } from '@umijs/max';
import { message, notification } from 'antd';
import { history } from '@umijs/max';

// 与后端约定的响应数据格式
interface ResponseStructure {
  success: boolean;
  data: any;
  errorCode?: number;
  errorMessage?: string;
}

/**
 * @name 错误处理
 * pro 自带的错误处理， 可以在这里做自己的改动
 * @doc https://umijs.org/docs/max/request#配置
 */
export const errorConfig: RequestConfig = {
  // 请求拦截器
  requestInterceptors: [
    (url: string, options: RequestOptions) => {
      // const token = localStorage.getItem('token') || '';
      const { data, method, params } = options;
      // 兼容antd默认数据格式
      const query = { ...data, ...params }
      // 针对列表接口参数处理
      if (query?.current && query?.pageSize) {
        query.page = query.current
        query.size = query.pageSize
        delete query.current
        delete query.pageSize
      }
      const requestData = { params: {}, data: {} }
      if (method?.toLowerCase() === 'get') {
        requestData.params = query
      } else {
        requestData.data = query
      }
      return {
        url,
        options: { ...options, ...requestData, interceptors: true, headers: { 'x-sign': 'va0GaiH8lahphee8' } },
      };
    }
  ],

  // 响应拦截器
  responseInterceptors: [
    [(response: any) => {
      const { data } = response;
      if (data?.code === 200) {
        const resultData = { ...data }
        // 兼容数据结构
        if (resultData?.data?.records) {
          resultData.data.data = data.data.records
        }
        return { ...resultData, success: true, };
      }
      if (data?.code === 1003) {
        localStorage.setItem('token', '')
        history.replace('/user/login');
        return Promise.reject('请登录')
      }
      message.error(data?.msg || '请求失败！');
      return Promise.reject(data?.msg || '请求失败！')
    }, (error: any) => {
      message.error(error?.data?.msg || '请求失败！');
      return Promise.reject('网络请求失败')
    }],
  ],
};

/**
 * @name request 配置，可以配置错误处理
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
export const requestConfig: RequestConfig = {
  timeout: 60000,
  baseURL: process.env.GLOBAL_API_URL,
  ...errorConfig,
};